import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "icon text-primary"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseIconButton',
  props: {
  icon: String,
  image: String,
  color: {
    type: String,
    default: 'primary',
  },
  inverted: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["base-button--icon", `${__props.color}${__props.icon ? '' : ' no-icon'}${__props.inverted ? ' inverted' : ''}`])
  }, [
    (__props.icon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createElementVNode("i", {
            class: _normalizeClass(__props.icon)
          }, null, 2)
        ]))
      : (__props.image)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "image",
            style: _normalizeStyle({ 'background-image': __props.image })
          }, null, 4))
        : _createCommentVNode("", true),
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})